import Arrow from "./Arrow";
import CircleCheck from "./CircleCheck";
import CircleError from "./CircleError";
import CircleInfo from "./CircleInfo";
import CircleWarning from "./CircleWarning";
import Close from "./Close";
import Download from "./Download";
import Duration from "./Duration";
import Edit from "./Edit";
import Facebook from "./Facebook";
import Finance from "./Finance";
import Info from "./Info";
import Instagram from "./Instagram";
import Linkedin from "./Linkedin";
import Mail from "./Mail";
import Note from "./Note";
import Offer from "./Offer";
import Other from "./Other";
import Phone from "./Phone";
import Radio from "./Radio";
import TrustedPerson from "./TrustedPerson";
import ValidateError from "./ValidateError";
import ValidateSuccess from "./ValidateSuccess";
import Wishes from "./Wishes";
import Xing from "./Xing";
import Youtube from "./Youtube";
import Delete from "./Delete";
import Location from "./Location";
import Hamburger from "./Hamburger";
import MymoriaLogo from "./MymoriaLogo";
import MymoriaLogoWhite from "./MymoriaLogoWhite";
import ProvisionPortalLogo from "./ProvisionPortalLogo";
import Check from "./Check";
import RatingStar from "./RatingStar";
import Google from "./Google";
import EyeOn from "./EyeOn";
import EyeOff from "./EyeOff";
import Refresh from "./Refresh";
import Reload from "./Reload";
import Zoom from "./Zoom";
export default {
    Close: Close,
    CircleCheck: CircleCheck,
    CircleError: CircleError,
    CircleWarning: CircleWarning,
    CircleInfo: CircleInfo,
    Info: Info,
    Mail: Mail,
    Phone: Phone,
    Youtube: Youtube,
    Facebook: Facebook,
    Instagram: Instagram,
    Radio: Radio,
    ValidateError: ValidateError,
    ValidateSuccess: ValidateSuccess,
    Offer: Offer,
    Other: Other,
    Wishes: Wishes,
    Finance: Finance,
    TrustedPerson: TrustedPerson,
    Linkedin: Linkedin,
    Xing: Xing,
    Arrow: Arrow,
    Note: Note,
    Edit: Edit,
    Download: Download,
    Duration: Duration,
    Delete: Delete,
    Location: Location,
    Hamburger: Hamburger,
    MymoriaLogo: MymoriaLogo,
    ProvisionPortalLogo: ProvisionPortalLogo,
    Check: Check,
    RatingStar: RatingStar,
    Google: Google,
    MymoriaLogoWhite: MymoriaLogoWhite,
    EyeOff: EyeOff,
    EyeOn: EyeOn,
    Refresh: Refresh,
    Reload: Reload,
    Zoom: Zoom,
};
//# sourceMappingURL=index.js.map